/**
 * What a docket field may hold, on the browser's side.
 *
 * ⛔ THE SAME RULE AS THE API, DUPLICATED ON PURPOSE AND PINNED BY A TEST.
 *
 * `mc_number` and `dot_number` were compared as typed, so with "MC-555555" blocked and its
 * notes naming the fraud, "555555", "mc 555555" and "MC555555" each walked past the
 * do-not-use list and were added as a fresh prospect — three of five spellings, from the field
 * the intake form puts in front of an operator. The API keys them now
 * (`normaliseDocket` in backend/src/lib.mjs) and refuses a field that cannot be keyed.
 *
 * This is here so the form can say so before the round trip. It lives in its own `.js` module
 * rather than inside Board.jsx because the backend's test imports it to prove the two copies
 * agree, and Node cannot import a `.jsx` file — and because the first version of this had a
 * different rule from the API's ("contains a digit" against "contains a non-zero digit"), so
 * `MC-000000` — a placeholder this codebase uses in two other screens — passed the form and
 * 400'd at the API.
 */
export const DOCKET_MAX_DIGITS = 9;

/** A sentence for the operator, or null when the value is usable. */
export const docketComplaint = (v) => {
  const given = String(v === undefined || v === null ? '' : v).trim();
  if (!given) return null;
  const digits = given.replace(/\D/g, '').replace(/^0+/, '');
  if (!digits) return "That has no number in it. Leave it blank if you do not have the docket.";
  // ⛔ A PASTE IS THE DANGEROUS CASE, because it SUCCEEDS. "MC-123456 (verified 3/14/2026)"
  // keys as 1234563142026 — a docket that will never match anything again, so that carrier's
  // identity is uncheckable for the rest of its life while the real docket stays addable.
  if (digits.length > DOCKET_MAX_DIGITS) {
    return "That has too many digits for a docket number. Paste just the number — a note belongs in Notes.";
  }
  return null;
};
